import {ObjectFactory} from '@/config/objectFactory';
import {ApiRequest, QueryRecordsRequest} from '@/types/request';
import {ApiResponse, DriverProfile} from '@/types/response';
import {CommonUtils} from '@/util/commonUtils';
import {MedTransGoConstants} from '@/util/constants';
import {IDriverService} from '@/services/iDriverService';

export class DriverService implements IDriverService {
    public async getDriverList(baseURL: string, driverRequest: QueryRecordsRequest):
    Promise<ApiResponse<DriverProfile[]>> {
        const iHttpService = ObjectFactory.getHttpService();
        const queryRecordsRequest: QueryRecordsRequest = {
            conditions: driverRequest.conditions ? driverRequest.conditions : [],
            limit: driverRequest.limit  ? driverRequest.limit : MedTransGoConstants.PAGINATION_LIMIT,
            start: driverRequest.start ? driverRequest.start : 0,
        };
        const apiRequest: ApiRequest = {
            baseURL,
            data: queryRecordsRequest,
            url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/drivers`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<DriverProfile[]>(apiRequest);
        if (!response.success) {
            CommonUtils.showError(response);
        }
        return response;
    }
}
